var mobileNavigation = function (data) {
    var mobile = $(data.navBarContainer),
        isClosed = false,
        trigger = $(data.triggerContainer),
        overlay = $(data.overlayContainer);
    var hamburger_cross = function () {
        if (isClosed === true) {
            overlay.hide();
            trigger.removeClass('is-open');
            mobile.removeClass('nav-bar-open');
            mobile.css(data.float,"-100%");
            trigger.addClass('is-closed');
            mobile.addClass('nav-bar-close');
            $('body').css({ overflow: "auto" });
            isClosed = false;
        } else {
            overlay.show();
            trigger.removeClass('is-closed');
            mobile.removeClass('nav-bar-close');
            trigger.addClass('is-open');
            mobile.addClass('nav-bar-open');
            mobile.css(data.float,"0");
            $('body').css({ overflow: "hidden" });
            isClosed = true;
        }
    };
    trigger.click(function () {
        hamburger_cross();
    });
    overlay.click(function () {
        hamburger_cross();
    });

    $('.header_menu_nav').children().clone().removeClass('col').appendTo('.mobile_menu');

    var mobile_nav = $('.mobile_menu > li');
    mobile_nav.has('ul').each(function () {
        $(this).addClass('hasChild');
    });

    $('.hasChild > a').click(function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('open');
        $(this).parent().children('.nova_nav_submenu').slideToggle();
    });

};

jQuery(document).ready(function($){
    var data = {
        float: 'left',
        navBarContainer: '.nav-bar',
        triggerContainer: '.hamburger',
        overlayContainer: '.mobile-overlay'
    };
    mobileNavigation(data);
});
